module.exports = __webpack_public_path__ + "img/list.6c9e1418.svg";